import $ from 'jquery';
import _ from 'underscore';
import { crossPageSelectHeadRow } from '@bingads-webui/projection-grid-cross-page-select-all';
import { helpers } from '@bingads-webui/projection-grid-toolbar';
import { TargetingSettingsContext } from './targeting-settings-context';
import { TargetingScope, TargetingLevel } from './config';
import { getFilterStateConfig } from './filter-state-config';

const { toolbarRow } = helpers;

export function getReportEmailRule(entity) {
  const stateReportEmailRule = TargetingSettingsContext.state.get('$ReportEmailRule');
  if (stateReportEmailRule && stateReportEmailRule.Entity === entity) {
    TargetingSettingsContext.state.unset('$ReportEmailRule');
    return stateReportEmailRule;
  }
  return null;
}

export const pluginConfig = (view, columnChooser) => {
  const setting = view.model.get('setting');
  const scope = view.model.get('scope');
  const level = view.model.get('level');

  const inlineDownloadEntity =
  (scope === TargetingScope.AdGroup || level === TargetingLevel.AdGroup) ? 'AdGroupCriterion' : 'CampaignCriterion';

  return {
    pagination: {
      pageSize: 20,
      availablePageSizes: [20, 50, 100, 200],
      enableRandomPage: false,
      pageNumberLabelText: TargetingSettingsContext.i18n.getString('Grid_Page_Colon'),
      pageSizeText: TargetingSettingsContext.i18n.getString('Grid_ShowRows'),
      totalPageCountText: TargetingSettingsContext.i18n.getString('Grid_PageOf'),
    },
    uiBlocker: {
      el: $('#child-page'),
    },
    placeholder: {
      viewRoot: view.$el,
      container: '.noresult-container',
      text: TargetingSettingsContext.i18n.getString('Grid_NoFilteredRecords'),
      filteredContainer: '.noresult-container',
      filteredEmptyText: TargetingSettingsContext.i18n.getString('Grid_NoFilteredRecords'),
    },
    columnChooser,
    inlineDownload: {
      DownloadView: TargetingSettingsContext.DownloadView,
      i18n: TargetingSettingsContext.i18n,
      s$i18n: TargetingSettingsContext.s$i18n,
      isAvailable: true,
      schema: TargetingSettingsContext[`s$${inlineDownloadEntity}`],
      gridId: '',
      ReportEmailRule: getReportEmailRule(inlineDownloadEntity),
    },
    filterState: _.defaults({
      container: view.$('.filter-bar'),
    }, getFilterStateConfig({ setting, level })),
    dateFilter: {
      isOdataActionSource: true,
      comparisonColumns: [
        'PeriodPerformanceMetrics',
        'PerformanceMetricsChange',
        'PerformanceMetricsChangePercentage',
      ],
    },
    popColumns: {
      i18n: TargetingSettingsContext.i18n,
    },
    editable: {
      i18n: TargetingSettingsContext.i18n,
    },
  };
};

export function scrollingConfig({
  sticky = false,
  virtualized = false,
} = {}) {
  const config = { virtualized };
  if (sticky) {
    config.header = {
      type: 'sticky',
      offset() {
        return $('nav.navbar-default.navbar-fixed-top').height();
      },
    };
  }

  return config;
}

export function selectionConfig(config) {
  return _.extend({
    enabled: true,
    headClasses: ['text-center'],
    bodyClasses: ['text-center'],
  }, config);
}

export function basicGridConfig() {
  return {
    tableClasses: ['table', 'table-bordered'],
    rows: {
      headRows: [
        toolbarRow('lower-toolbar'),
        crossPageSelectHeadRow(),
        'column-header-rows',
      ],
    },
    scrolling: scrollingConfig({
      sticky: true,
      virtualized: true,
    }),
    selection: selectionConfig(),
  };
}
